import React from 'react';
import { CheckCircle, Clock, AlertCircle } from 'lucide-react';

const BookingStatusBreakdown = ({ bookingsAnalytics = {} }) => {
 const byStatus = bookingsAnalytics.by_status || {};

 return (
 <div className="product-panel p-4 sm:p-6">
 <h3 className="text-sm font-semibold text-ink mb-4">Booking Status</h3>
 <div className="space-y-3">
 <div className="flex items-center justify-between">
 <div className="flex items-center gap-2">
 <CheckCircle className="w-4 h-4 text-emerald-600" />
 <span className="text-sm text-ink-secondary">Completed</span>
 </div>
 <span className="text-sm font-semibold text-ink">
 {byStatus.completed || 0}
 </span>
 </div>
 <div className="flex items-center justify-between">
 <div className="flex items-center gap-2">
 <Clock className="w-4 h-4 text-amber-600" />
 <span className="text-sm text-ink-secondary">Pending</span>
 </div>
 <span className="text-sm font-semibold text-ink">
 {byStatus.pending || 0}
 </span>
 </div>
 <div className="flex items-center justify-between">
 <div className="flex items-center gap-2">
 <AlertCircle className="w-4 h-4 text-red-600" />
 <span className="text-sm text-ink-secondary">Cancelled</span>
 </div>
 <span className="text-sm font-semibold text-ink">
 {byStatus.cancelled || 0}
 </span>
 </div>
 </div>
 </div>
 );
};

export default BookingStatusBreakdown;
